<template>
<div>  
    <b-table 
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage">
        <!--template v-slot:cell(actions)="data">
            <b-icon icon='list-check' @click='generateRtDepartures(data.item.tunnus)'/>
        </template-->
    </b-table>
    
    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
  
</div>    
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'
import timetable from '@/store/timetable/timetable'

export default {
    name: 'lineListTable',
    components: { TablePagination },
    props: ['filter'],
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            filteredRows: 0
        }
    },
    computed: {
        fields() {
            return [
                { key:"tunnus" , label: this.$t('line_view.id'), sortable: true },
                { key:"tunnusteksti" , label: this.$t('line_view.line_number'), sortable: true },
                { key:"nimi" , label: this.$t('line_view.name'), sortable: true },
                { key:"organisaatio" , label: this.$t('line_view.organisation'), sortable: true },
                /*{ key:"actions" , label: "", }*/
            ];
        },
        items () { 
            return this.$store.state.timetable.lines.list;
        },
        totalRows() {
            return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
        }               
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.$store.dispatch('timetable/getLinesListData');       
    },
    methods: {
        onRowSelected (items) {
            this.$emit('selectItem', items[0]);        
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page){
            this.currentPage = page;
        }
    }
}

</script>